import LexnetDialog from './components/LexnetDialog'

export default LexnetDialog
